import ServiceDeskCell from './component'

export default ServiceDeskCell
